export const GET_COMPANY_INFO_REQUEST = "GET_COMPANY_INFO_REQUEST";
export const GET_COMPANY_INFO_SUCCESS = "GET_COMPANY_INFO_SUCCESS";
export const GET_COMPANY_INFO_FAILURE = "GET_COMPANY_INFO_FAILURE";
export const getCompanyInfoRequest = (payload) => ({
    type: GET_COMPANY_INFO_REQUEST,
    payload,
});
export const getCompanyInfoSuccess = (payload) => ({
    type: GET_COMPANY_INFO_SUCCESS,
    payload,
});
export const getCompanyInfoFailure = (payload) => ({
    type: GET_COMPANY_INFO_FAILURE,
    payload,
});
